import { moduleDefaultConfig } from "../../../config/moduleDefaultConfig"
let moduleConfig = {}
moduleConfig = {
    ...moduleDefaultConfig
};

moduleConfig.title = 'Media Gallery';
moduleConfig.singleItemTitle = 'Media Gallery';
moduleConfig.url = 'media-gallery-albums';
moduleConfig.moduleType = {
    listing: 'block',
    view: 'block'
};


moduleConfig.bulkActions = [
    {
        displayName: "Archive Selected",
        value: "Archive"
    },
    {
        displayName: "Restore Selected",
        value: "Restore"
    }
];


export default moduleConfig;